import { render, staticRenderFns } from "./viewFileH5.vue?vue&type=template&id=070c4a5a&scoped=true&lang=pug"
import script from "./viewFileH5.vue?vue&type=script&lang=js"
export * from "./viewFileH5.vue?vue&type=script&lang=js"
import style0 from "./viewFileH5.vue?vue&type=style&index=0&id=070c4a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070c4a5a",
  null
  
)

export default component.exports